import { z } from 'zod'

export const ApiLoginResponseSchema = z.object({
  store_name: z.string(),
  store_address: z.string().optional(),
  store_avatar: z.string(),
  store_id: z.string(),
  owner_name: z.string(),
  email: z.string().email(),
  rest_status: z.number(),
  availability: z.number(),
  message: z.string(),
  currency_code: z.string(),
  currency_symbol: z.string(),
  country_code: z.string(),
  phone_number: z.string(),
  isMainRest: z.boolean(),
  store_type: z.union([
    z.literal('dark_store'),
    z.literal('restaurant'),
    z.literal('store')
  ]),
  usingCashCo: z.boolean(),
  token: z.string()
})

export type ApiLoginResponse = z.infer<typeof ApiLoginResponseSchema>
